import React, { useEffect, useState, useMemo } from "react";
import { Card, Box, Typography } from "@mui/material";
import '../../../cssfiles/homepage.css'
import { useSelector, useDispatch } from 'react-redux';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Basicprops from "./Basicprops";
import Extendedprops from "./Extendedprops";
import Valuescard from "../../Widgets/Valuescard";
import Valuecardprops from "./Widgetextendedprops/Valuecardprops";
import Linechartcard from "../../Widgets/Linechartcard";
// import Leafletmapcard from "../../Widgets/Leafletmapcard";
import Linechartcardprops from "./Widgetextendedprops/Linechartcardprops";
// import Leafletmapcardprops from "./Widgetextendedprops/Leafletmapcardprops";
import Barchartcard from "../../Widgets/Barchartcard";
import Areachartcard from "../../Widgets/Areachartcard";
import Piechartcard from "../../Widgets/Piechartcard";
import Barchartcardprops from "./Widgetextendedprops/Barchartcardprops";
import Areachartcardprops from "./Widgetextendedprops/Areachartcardprops";
import Piechartcardprops from "./Widgetextendedprops/Piechartcardprops";
import Googlemaps from "../../Widgets/Googlemaps";
// import Azuremaps from "../../Widgets/Azuremaps";
import Circulargaugecard from "../../Widgets/Circulargaugecard";
import Semicirculargaugecard from "../../Widgets/Semicirculargaugecard";
import Speedgauge from "../../Widgets/Speedgauge";
import Lineargauge from "../../Widgets/Lineargauge";
import Temperaturegauge from "../../Widgets/Temperaturegauge";
import Timeseriestable from "../../Widgets/Timeseriestable";
import Statuscard from "../../Widgets/Statuscard";
import Setdatacard from "../../Widgets/Setdatacard";
import Switchcard from "../../Widgets/Switchcard";
import { WidthProvider, Responsive } from "react-grid-layout";
import 'react-grid-layout/css/styles.css'
import { updateselectedbasicprops } from "../../../store/cofig_data";

//var counter = 1
export default function Widgetcreateupdate(props) {
    const dispatch = useDispatch()
    const ResponsiveReactGridLayout = useMemo(() => WidthProvider(Responsive), []);
    const theme = useSelector((state) => state.themedata.theme)
    const widgetname = useSelector((state) => state.configdata.editwidgetselect)
    const basicprops = useSelector((state) => state.configdata.editbasicprops)
    const extendedprop = useSelector((state) => state.configdata.editextendedprops)

    var tablist = ["Basic", "Extended"]

    const [tabselected, setTabselected] = useState("Basic")
    const [title, setTitle] = useState("New Widget")
    const [fontsize, setFontsize] = useState(16)
    const [fonttype, setFonttype] = useState("Roboto")
    const [textcolor, setTextcolor] = useState('#005C8E')
    const [backcolor, setBackcolor] = useState('#FFFFFF')
    const [bordercolor, setbordercolor] = useState('#005C8E')
    const [bordersize, setBordersize] = useState(0)
    const [borderradius, setBorderradius] = useState(0)
    const [extendprops, setExtendedprops] = useState()
    const [wheight, setWheight] = useState(2)
    const [wwidth, setWwidth] = useState(3)

    //const [basicprops, setBasicprops] = useState()

    const handlesectabchange = (event, newValue) => {
        setTabselected(newValue)
    }

    useEffect(() => {
        //console.log("selected widget ",widgetname, basicprops)
    },[])

    useEffect(() => {
        //console.log("basicprops ",basicprops)
        if(basicprops != "") {
            var bprops = JSON.parse(basicprops)
            var extprops = extendedprop
            setTitle(bprops.widgetname)
            setFontsize(bprops?.font_data?.fontsize)
            setFonttype(bprops?.font_data?.fonttype)
            if(theme === 'light') {
                setTextcolor(bprops.color.light.text)
                setBackcolor(bprops.color.light.background)
                setbordercolor(bprops.color.light.border)
            } else {
                setTextcolor(bprops.color.dark.text)
                setBackcolor(bprops.color.dark.background)
                setbordercolor(bprops.color.dark.border)
            }
            setBordersize(bprops.border.bordersize)
            setBorderradius(bprops.border.borderradius)
            //console.log("extprops ",extprops)
        }
        if(extendedprop != "") {
            var extprops = JSON.parse(extendedprop)
        }
            
    },[theme])

    const handlebasicpropsupdate = (propsdata) => {
        //console.log("propsdata ",propsdata, theme)
        setTitle(propsdata.widgetname)
        setFontsize(propsdata.font_data.fontsize)
        setFonttype(propsdata.font_data.fonttype)
        if(theme === 'light') {
            setTextcolor(propsdata.color.light.text)
            setBackcolor(propsdata.color.light.background)
            setbordercolor(propsdata.color.light.border)
        } else {
            setTextcolor(propsdata.color.dark.text)
            setBackcolor(propsdata.color.dark.background)
            setbordercolor(propsdata.color.dark.border)
        }
        setBordersize(propsdata.border.bordersize)
        setBorderradius(propsdata.border.borderradius)
    }

    const handleextendedpropsupdate = (propsdata) => {
        //console.log("extend props ", propsdata)
        //counter = counter + 1
        var updatejosn = {...propsdata}
        setExtendedprops(updatejosn)
    }

    const onLayoutChangemainpage = (layout, layouts) => {
        console.log("layoutmain ",layout)
        if(basicprops !== '' && basicprops !== undefined) {
            var bprops = JSON.parse(basicprops)
            setWheight(layout[0].h)
            setWwidth(layout[0].w)
            bprops.size.height = layout[0].h
            bprops.size.width = layout[0].w
            console.log("bprops ", bprops)
            dispatch(updateselectedbasicprops(JSON.stringify(bprops)))
        }
        //setLayoutchange(layout)
    }

    var obj = {
        i: "1",
        x: 0,
        y: 0,
        w: 2,
        h: 6,
        minW: 1,
        minH: 1,
        maxH: 20,
    };

    return(
        <div style={{display: 'flex', flexDirection: 'row', gap: 5, width: '100%', height: '100%'}}>
            <div style={{width: '45%', alignItems: 'center', justifyContent: 'center', display: 'flex'}}>
                <div style={{width: '100%', height: '100%'}}>
                    <ResponsiveReactGridLayout
                        breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
                        cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
                        rowHeight={30}
                        margin={[5,5]}
                        allowOverlap={false}
                        resizeHandles= {['se']}
                        isResizable= {true}
                        isDraggable= {false}
                        onLayoutChange={(layout, layouts) => onLayoutChangemainpage(layout, layouts)}
                    >
                        <div key={1} data-grid={obj} style={{backgroundColor: 'green'}}>
                            <div style={{height: '100%'}}>
                                <Card elevation={0} sx={{backgroundColor: backcolor, borderRadius: borderradius+'px', border: bordersize+'px solid '+bordercolor, height: '100%'}}> 
                                    <Box sx={{height: '30px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                        <Typography sx={{marginTop:"8px", paddingLeft: '15px', color: textcolor, fontSize: fontsize+'px', fontWeight: 700, fontFamily:fonttype}}> {title} </Typography>
                                        <Typography style={{flexGrow: 1}}> </Typography>
                                    </Box>
                                    <Box sx={{height: '100%', width: '100%', textAlign: 'center'}}>
                                        {widgetname === "Single Value" && <Valuescard extendedprops={extendprops}/>}
                                        {widgetname === "Line Chart" && <Linechartcard extendedprops={extendprops}/>}
                                        {/* {widgetname === "Leaflet Map" && <Leafletmapcard extendedprops={extendprops}/>} */}
                                        {widgetname === "Bar Chart" && <Barchartcard extendedprops={extendprops}/>}
                                        {widgetname === "Area Chart" && <Areachartcard extendedprops={extendprops}/>}
                                        {widgetname === "Pie Chart" && <Piechartcard extendedprops={extendprops}/>}
                                        {widgetname === "Google Map" && <Googlemaps extendedprops={extendprops}/>}
                                        {/* {widgetname === "Azure Map" && <Azuremaps extendedprops={extendprops}/>} */}
                                        {widgetname === "Circular Gauge" && <Circulargaugecard extendedprops={extendprops}/>}
                                        {widgetname === "Semi Circular Gauge" && <Semicirculargaugecard extendedprops={extendprops}/>}
                                        {widgetname === "Speed Gauge" && <Speedgauge extendedprops={extendprops}/>}
                                        {widgetname === "Linear Gauge" && <Lineargauge extendedprops={extendprops}/>}
                                        {widgetname === "Temperature Gauge" && <Temperaturegauge extendedprops={extendprops}/>}
                                        {widgetname === "Timeseries Table" && <Timeseriestable extendedprops={extendprops}/>}
                                        {widgetname === "Status" && <Statuscard extendedprops={extendprops}/>}
                                        {widgetname === "Set Value" && <Setdatacard extendedprops={extendprops}/>}
                                        {widgetname === "Switch" && <Switchcard extendedprops={extendprops}/>}
                                    </Box>
                                </Card>
                            </div>
                        </div>
                    </ResponsiveReactGridLayout>
                </div>
            </div>
            <div style={{ width: '55%'}}>
                <Tabs
                    value={tabselected}
                    onChange={handlesectabchange}
                    sx={{
                        '& .MuiTabs-indicator': {
                            margin: '0px !important',
                            height: '0px',
                            borderRadius: '0px',
                            backgroundColor: '#1E8EFA',
                            borderBottom: "1px solid  theme === 'dark' ? '#000000' : '#FFFFFF'"
                        },
                        '& .Mui-selected': {
                            color: '#008CD7 !important',
                            fontWeight: '700 !important',
                            backgroundColor: theme === 'dark' ? '#000000' : '#FFFFFF',
                            borderTop: "1px solid #008CD7",
                            borderLeft: "1px solid #008CD7",
                            borderRight: "1px solid #008CD7",
                            borderBottom: "1px solid theme === 'dark' ? '#000000' : '#FFFFFF'",
                        },
                        '& .MuiTab-root': {
                            padding: '8px 8px 4px 8px!important',
                            margin: '0px !important',
                            minWidth: '63px'
                        },
                        minHeight:'28px',
                        marginBottom:'-1px'
                    }}
                >
                    {
                        tablist.map((tab) => {
                            return(
                                <Tab
                                    sx={{
                                        minHeight: '30px',
                                        height: '30px'
                                    }}
                                    style={{
                                        color: theme === 'dark' ? '#C1C1C1' :'#3C3C3C',
                                        fontFamily: 'Roboto',
                                        fontSize: '14px',
                                        fontWeight: 400,
                                        lineHeight: '16.75px',
                                        textTransform: 'capitalize'
                                    }}
                                    value={tab}
                                    label={tab}
                                >
                                    {tab}
                                </Tab>
                            )
                        })
                    }
                </Tabs>
                <Box style={{width: '100%', height: 'calc(100% - 30px)', overflow: 'auto',backgroundColor: theme === 'dark' ? '#000000' : '#FFFFFF', border: "1px solid #008CD7"}}>
                    {tabselected === "Basic" && 
                        <div style={{height: '100%', overflow: 'auto', padding: '20px'}}>
                            <Basicprops callbackpropsupdate = {handlebasicpropsupdate}
                             type={props.type} widgettype={widgetname} 
                             height={wheight} width={wwidth}
                             />
                        </div>
                    }
                    {tabselected === "Extended" && 
                        <div style={{height: '100%', overflow: 'auto', padding: '20px'}}>
                            {widgetname === "Single Value" && <Valuecardprops callbackpropsupdate = {handleextendedpropsupdate} type={props.type} widgettype={widgetname}/>}
                            {/* {widgetname === "Leaflet Map" && <Leafletmapcardprops callbackpropsupdate = {handleextendedpropsupdate} type={props.type} widgettype={widgetname}/>} */}
                            {widgetname === "Line Chart" && <Linechartcardprops callbackpropsupdate = {handleextendedpropsupdate} type={props.type} widgettype={widgetname}/>}
                            {widgetname === "Bar Chart" && <Barchartcardprops callbackpropsupdate = {handleextendedpropsupdate} type={props.type} widgettype={widgetname}/>}
                            {widgetname === "Area Chart" && <Areachartcardprops callbackpropsupdate = {handleextendedpropsupdate} type={props.type} widgettype={widgetname}/>}
                            {widgetname === "Pie Chart" && <Linechartcardprops callbackpropsupdate = {handleextendedpropsupdate} type={props.type} widgettype={widgetname}/>}
                            {/*<Extendedprops callbackpropsupdate = {handleextendedpropsupdate} type={props.type} widgettype={widgetname}/>*/}
                        </div>
                    }
                </Box>
            </div>
        </div>
    )
}